
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/naytareferenssi/[slug]/[contentContainerId]",
      function () {
        return require("private-next-pages/naytareferenssi/[slug]/[contentContainerId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/naytareferenssi/[slug]/[contentContainerId]"])
      });
    }
  